import React from "react";
import "./ClubsApp.css";
import acmIcon from "./assets/acm.png";
import cccIcon from "./assets/ccc.png";
import redcrossIcon from "./assets/redcross.png";
import mentorcollectiveIcon from "./assets/mentorcollective.png";
import thetatauIcon from "./assets/thetatau.png";

const ClubsApp = () => {
  const clubs = [
    {
      id: 1,
      name: "Theta Tau",
      role: "Web Developer",
      period: "2022 - Present",
      description:
        "Developed and maintained the official website for UC Riverside's Theta Tau. Collaborated with a team to implement new features and improve user experience.",
      icon: thetatauIcon,
    },
    {
      id: 2,
      name: "Association for Computing Machinery (ACM)",
      role: "Hack-a-Thon Web Developer",
      period: "2021 - Present",
      description:
        "Participated in developing and maintaining the official website for ACM's hackathon events.",
      icon: acmIcon,
    },
    {
      id: 3,
      name: "Competitive Coding Club",
      role: "Competitor",
      period: "2022 - Present",
      description:
        "Practice competitive programming problems and participate in coding contests. Improve algorithmic problem-solving skills.",
      icon: cccIcon,
    },
    {
      id: 4,
      name: "Red Cross",
      role: "Volunteer",
      period: "2017 - Present",
      description:
        "Volunteer at community events and blood drives. Help organize disaster relief efforts and fundraising campaigns.",
      icon: redcrossIcon,
    },
    {
      id: 5,
      name: "Mentor Collective",
      role: "Mentor",
      period: "2022 - 2025",
      description:
        "Provided guidance to new first-year Computer Science students. Helped developed career skills and networking opportunities.",
      icon: mentorcollectiveIcon,
    },
  ];

  return (
    <div className="clubs-app">
      <div className="notebook-container">
        <div className="notebook-header">
          <h1 className="notebook-title">Clubs & Organizations</h1>
          <div className="notebook-rings">
            <div className="ring"></div>
            <div className="ring"></div>
            <div className="ring"></div>
          </div>
        </div>

        <div className="notebook-pages">
          {clubs.map((club, index) => (
            <div key={club.id} className="notebook-entry">
              <div className="entry-icon">
                <img
                  src={club.icon}
                  alt={club.name}
                  className="club-icon-img"
                />
              </div>
              <div className="entry-content">
                <div className="entry-header">
                  <h2 className="club-name">{club.name}</h2>
                  <span className="club-period">{club.period}</span>
                </div>
                <div className="club-role">{club.role}</div>
                <p className="club-description">{club.description}</p>
              </div>
              {index < clubs.length - 1 && (
                <div className="entry-divider"></div>
              )}
            </div>
          ))}
        </div>

        <div className="notebook-footer">
          <div className="page-lines"></div>
        </div>
      </div>
    </div>
  );
};

export default ClubsApp;
